import React from 'react';
import { FaLinkedin, FaGithub } from 'react-icons/fa';
import { MdEmail } from 'react-icons/md';

function Footer() {
    return (
        <footer className="footer text-white py-4">
          <div className='container mx-auto flex justify-between items-center'>
            <div className="flex space-x-4">
              {/* LinkedIn */}
              <a
                href="https://linkedin.com/in/aaryaapatel"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-blue-500"
              >
                <FaLinkedin className="w-5 h-5 md:w-6 md:h-6" />
              </a>
        
              {/* Email */}
              <a
                href="mailto:aaryap251@gmail.com"
                className="hover:text-red-500"
              >
                <MdEmail className="w-5 h-5 md:w-6 md:h-6" />
              </a>
        
              {/* GitHub */}
              <a
                href="https://github.com/AwesomeFalcon"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-gray-500"
              >
                <FaGithub className="w-5 h-5 md:w-6 md:h-6" />
              </a>
            </div>
            <p className="text-base">Made with &#x1F49A; by Aarya Patel</p>
          </div>
      </footer>
    );
  }
  
  export default Footer;